import Flickity from 'flickity';
require('flickity-imagesloaded');

window.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelector('.image-carousel__slides');

  if (slides) {
    new Flickity(slides, {
      imagesLoaded: true,
      contain: true,
      cellAlign: 'center',
      groupCells: 1,
      adaptiveHeight: true,
      pageDots: false,
      wrapAround: true,
      selectedAttraction: 0.028,
      friction: 0.25,
      arrowShape: {
        x0: 10,
        x1: 50,
        y1: 40,
        x2: 55,
        y2: 35,
        x3: 20
      }
    });
  }
});
